// contexts/ShiftRotaContext.js
import React, { createContext, useContext, useState, useRef } from "react";

const ShiftRotaContext = createContext();

export const useShiftRota = () => {
  const context = useContext(ShiftRotaContext);
  if (!context) {
    throw new Error("useShiftRota must be used within a ShiftRotaProvider");
  }
  return context;
};

export const ShiftRotaProvider = ({ children }) => {
  // State that was previously passed as props
  const [activeStep, setActiveStep] = useState(0);
  const [representationWeekdays, setRepresentationWeekdays] = useState([]);
  const [representationShifts, setRepresentationShifts] = useState([]);
  const [shiftRotationDetails, setShiftRotationDetails] = useState([]);
  const [representationNonRandon, setRepresentationNonRandom] = useState([]);
  const [sftAssignId, setSftAssignId] = useState("");
  const [editSftRotaData, setEditSftRotaData] = useState("");
  const [getShiftRotaData, setGetShiftRotaData] = useState(false);
  const [isDateModified, setIsDateModified] = useState(false);
  const [formData, setFormData] = useState({
    config: {},
    schedule: {},
    preview: {},
  });
  const [WeekDaysData, setWeekDaysData] = useState([]);
  const [allGroupDetails, setAllGroupDetails] = useState([]);
  const [shiftCycleDetails, setShiftCycleDetails] = useState([]);
  const [expandPage, setExpandPage] = useState(false);
  const [isEditPanelOpen, setIsEditPanelOpen] = useState(false);
  const [dataUpdated, setDataUpdated] = useState(false);
  const [weekDayRepresentation, setWeekDayRepresentation] = useState([]);
  const [shiftRepresentation, setShiftRepresentation] = useState([]);
  const [rotationDetails, setRotationDetails] = useState([]);
  const [randonRepresentation, setRandomRepresentation] = useState([]);
  const [noOfSft, setNumberOfSft] = useState(
    formData?.config?.no_of_shifts === "1" ? true : false
  );
  const configRef = useRef();

  const generateShiftMatrics = (sftGrpData, sftData) => {
    let cycle = sftData?.length;
    let additionalShiftGroupWithPrimary = sftGrpData.map((group) => ({
      ...group,
      shifts: [...sftData],
    }));
    setAllGroupDetails(additionalShiftGroupWithPrimary);
    let shiftgorup = additionalShiftGroupWithPrimary?.length;
    if (sftGrpData?.length !== 0) {
      let cycles = [];
      for (let index = 1; index <= parseInt(cycle); index++) {
        let groupwithCycleShift = [];
        for (
          let indexshift = 0;
          indexshift < parseInt(shiftgorup);
          indexshift++
        ) {
          let cycleDetails = {
            shift_group_id: additionalShiftGroupWithPrimary[indexshift]?.id,
            shift_group_name: additionalShiftGroupWithPrimary[indexshift]?.name,
            shift_id: "",
            shift_name: "",
            shiftDetails: additionalShiftGroupWithPrimary[indexshift]?.shifts,
          };
          groupwithCycleShift = [...groupwithCycleShift, cycleDetails];
        }
        cycles = [
          ...cycles,
          {
            cycle_number: index,
            assignments: groupwithCycleShift,
          },
        ];
      }
      setShiftCycleDetails(cycles);
    }
    if (sftGrpData?.length !== 0) {
      let groupCycle = [];
      additionalShiftGroupWithPrimary.forEach((element) => {
        let cycleDetails = [];
        for (let index = 1; index <= parseInt(cycle); index++) {
          let data = [
            {
              weekday: "Monday",
              shift_id: "",
              shift_name: "",
              shift_color: "",
            },
            {
              weekday: "Tuesday",
              shift_id: "",
              shift_name: "",
              shift_color: "",
            },
            {
              weekday: "Wednesday",
              shift_id: "",
              shift_name: "",
              shift_color: "",
            },
            {
              weekday: "Thursday",
              shift_id: "",
              shift_name: "",
              shift_color: "",
            },
            {
              weekday: "Friday",
              shift_id: "",
              shift_name: "",
              shift_color: "",
            },
            {
              weekday: "Saturday",
              shift_id: "",
              shift_name: "",
              shift_color: "",
            },
            {
              weekday: "Sunday",
              shift_id: "",
              shift_name: "",
              shift_color: "",
            },
          ];
          cycleDetails = [
            ...cycleDetails,
            {
              cycle_number: index,
              assignments: data,
            },
          ];
        }
        groupCycle = [
          ...groupCycle,
          {
            shift_group_id: element?.id,
            group_name: element?.name,
            shiftDetails: element?.shifts,
            cycles: cycleDetails,
          },
        ];
      });
      setWeekDaysData(groupCycle);
    }
  };

  const value = {
    // State
    configRef,
    noOfSft,
    setNumberOfSft,
    activeStep,
    setActiveStep,
    isDateModified,
    setIsDateModified,
    representationWeekdays,
    setRepresentationWeekdays,
    representationShifts,
    setRepresentationShifts,
    shiftRotationDetails,
    setShiftRotationDetails,
    representationNonRandon,
    setRepresentationNonRandom,
    sftAssignId,
    setSftAssignId,
    editSftRotaData,
    setEditSftRotaData,
    getShiftRotaData,
    setGetShiftRotaData,
    formData,
    setFormData,
    WeekDaysData,
    setWeekDaysData,
    allGroupDetails,
    setAllGroupDetails,
    shiftCycleDetails,
    setShiftCycleDetails,
    expandPage,
    setExpandPage,
    isEditPanelOpen,
    setIsEditPanelOpen,
    dataUpdated,
    setDataUpdated,
    weekDayRepresentation,
    setWeekDayRepresentation,
    shiftRepresentation,
    setShiftRepresentation,
    rotationDetails,
    setRotationDetails,
    randonRepresentation,
    setRandomRepresentation,
    generateShiftMatrics,
  };

  return (
    <ShiftRotaContext.Provider value={value}>
      {children}
    </ShiftRotaContext.Provider>
  );
};
